import { COMPONENT_STATES, COMPONENT_TYPE, DEFAULT_MEDIA_QUERY_PLATFORMS } from 'common/constants';
import { OTHER_PROPS } from 'common/constants/component-props';
import { SHAPE_TYPE } from './constants';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock } from '../creation-types';

export const shape = (): CreatedBuildingBlock<typeof COMPONENT_TYPE.SHAPE> =>
	createModel({
		type: COMPONENT_TYPE.SHAPE,
		componentProps: {
			other: {
				[COMPONENT_STATES.DEFAULT]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
						[OTHER_PROPS.shape.shapeType]: SHAPE_TYPE.RECT,
					},
				},
			},
			styles: {},
		},
		children: [],
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.SHAPE>;
